import { useMemo } from 'react';
import type { JourneyPickerCategory } from 'voyager';
import { useTranslations } from '@lang';
import { useLabels } from '@features/Menu/useLabels';

type CategoryConfig = {
  id: string;
  translationKey: string;
  labelKey: string;
};

const CATEGORY_CONFIG: CategoryConfig[] = [
  { id: 'rooms', translationKey: 'app.rooms', labelKey: 'rooms' },
  { id: 'rates', translationKey: 'app.rates', labelKey: 'rates' },
  { id: 'spa', translationKey: 'category.spaDays', labelKey: 'spadays' },
  { id: 'treatments', translationKey: 'app.spaTreatments', labelKey: 'treatments' },
  { id: 'facilities', translationKey: 'app.facilities', labelKey: 'facilities' },
  { id: 'classes', translationKey: 'common.classes', labelKey: 'classes' },
  { id: 'dining', translationKey: 'app.dining', labelKey: 'tables' },
];

export function useNavCategories(): JourneyPickerCategory[] {
  const { t } = useTranslations();
  const labels = useLabels();

  return useMemo(
    () =>
      CATEGORY_CONFIG.map(({ id, translationKey, labelKey }) => ({
        id,
        label: labels?.[labelKey] || t(translationKey as Parameters<typeof t>[0]),
      })),
    [t, labels]
  );
}
